import React, { ReactNode } from 'react'
import CssBaseline from '@material-ui/core/CssBaseline'
import { observer, inject } from 'mobx-react'
import { AppStore } from './stores/app-store'
import { SimpleDialogManager } from './components/simple-dialog/simple-dialog'
import { DialogStore, ERROR } from './stores/dialog-store'
import { SnackbarManager } from './components/snackbar-manager/snackbar-manager'
import { config } from './config/config'
import { Spinner } from './components/spinner/spinner'

interface AppProps {
  appStore?: AppStore
  dialogStore?: DialogStore
  children?: ReactNode
}

@inject(DialogStore.storeName)
@inject(AppStore.storeName)
@observer
export class App extends React.Component<AppProps> {

  constructor(props: AppProps) {
    super(props)

    window.addEventListener('unhandledrejection', evt => {
      this.showError(evt.reason as Error)
    })

    window.addEventListener('error', evt => {
      this.showError(evt.error as Error)
    })
  }

  componentDidMount(): void {
    if (window['Cypress']) {
      window['config'] = config // now is only needed for tests
      window['appReady'] = true
    }
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo): void {
    this.showError(error, errorInfo)
  }

  showError = (error: Error, errorInfo?: React.ErrorInfo) => {
    console.error(error)
    console.error('errorInfo: ', errorInfo)

    const { showDialog } = this.props.dialogStore

    showDialog({
      title: 'Произошла ошибка',
      message: `Обратитесь в службу поддержки по адресу support.crystals.ru
            ` + JSON.stringify({
        error: {
          name: error.name,
          message: error.message,
          stack: error.stack,
        },
        route: window.location.pathname,
        ...(errorInfo || {})
      }),
      mode: ERROR,
    })
  }

  render() {
    const { loading } = this.props.appStore

    return (
        <>
          <CssBaseline />
          {loading && <Spinner />}
          { this.props.children }
          <SimpleDialogManager />
          <SnackbarManager />
        </>
    )
  }
}
